import React from "react";
import Select from "@mui/material/Select";
import { InputLabel, MenuItem } from "@mui/material";
import FormControl from "@mui/material/FormControl";

const TextDirectionSelect = props => {
  const { onChange, label = "Text Directionality", value } = props;

  return (
    <FormControl fullWidth>
      <InputLabel htmlFor="content-textDirectionality">{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        inputProps={{
          name: "content-textDirectionality",
          id: "content-textDirectionality",
        }}
      >
        <MenuItem value="LTR" key="LTR">
          Left to Right
        </MenuItem>
        <MenuItem value="RTL" key="RTL">
          Right to Left
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default TextDirectionSelect;
